const baseUrl = 'https://react-project-1-h8.herokuapp.com';

export function fetchCategories() {
  return (dispatch, getState) => {
    fetch(`${baseUrl}/categories`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        dispatch({
          type: 'categories/fetchSuccess',
          payload: data
        })
      })
  }
}

export function fetchSubCategories() {
  return (dispatch, getState) => {
    fetch(`${baseUrl}/sub-categories`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        dispatch({
          type: 'subCategories/fetchSuccess',
          payload: data
        })
      })
  }
}

export function fetchSubCategory(id) {
  return (dispatch, getState) => {
    fetch(`${baseUrl}/sub-categories/${id}`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        dispatch({
          type: 'subCategory/fetchSuccess',
          payload: data
        })
      })
  }
}

export function fetchProducts(subCatId) {
  return (dispatch, getState) => {
    dispatch({ type: 'loading/true' });
    fetch(`${baseUrl}/products${subCatId ? '?cat=' + subCatId : ''}`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        dispatch({
          type: 'products/fetchSuccess',
          payload: data
        })
      })
      .finally(() => {
        setTimeout(() => {
          dispatch({ type: 'loading/false' });
        }, 500);
      })
  }
}

export function fetchLatestProducts(subCatId) {
  return (dispatch, getState) => {
    fetch(`${baseUrl}/products/latest`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        dispatch({
          type: 'productsLatest/fetchSuccess',
          payload: data
        })
      })
  }
}

export function fetchProduct(id) {
  return (dispatch, getState) => {
    dispatch({ type: 'loading/true' });
    fetch(`${baseUrl}/products/${id}`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        dispatch({
          type: 'product/fetchSuccess',
          payload: data
        })
      })
      .finally(() => {
        setTimeout(() => {
          dispatch({ type: 'loading/false' });
        }, 500);
      })
  }
}

